var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"VYl6vlFmGQCph940bxNz8"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';
import createSentryBeforeSend from '@rockalingua/shared/monitoring/functions/createSentryBeforeSend';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_STAGE,
  tracesSampleRate: 0.0,
  beforeSend: createSentryBeforeSend('web', process.env.NEXT_PUBLIC_STAGE),
});
